import { FunctionComponent } from 'react';
// import { Alert } from '@mui/lab';

import { useAlertStyles } from './Alert.styles';
import CloseIcon from '../../static/closeIcon.svg?react';
import { useTheme, Alert } from '@mui/material';
interface AlertProps {
  message: any | string;
  severity: any;
  onClose?(): void;
  className?: string;
}

export const CustomAlert: FunctionComponent<AlertProps> = ({
  message,
  severity = 'info',
  onClose,
  className,
}) => {
  const { classes } = useAlertStyles();
  const theme = useTheme();

  return (
    <Alert
      className={`${className} ${classes.alert}`}
      variant="filled"
      severity={severity}
      sx={{
        backgroundColor: () => {
          switch (severity) {
            case 'error':
              return '#f8d7da';
            case 'warning':
              return '#fff3cd';
            case 'success':
              return '#d1e7dd';
            default:
              return '#cff4fc';
          }
        },
        color: () => {
          switch (severity) {
            case 'error':
              return '#842029';
            case 'warning':
              return '#664d03';
            case 'success':
              return '#0f5132';
            default:
              return '#055160';
          }
        },
        fontWeight: 'bold',
        border: () => {
          switch (severity) {
            case 'error':
              return '1px solid #f5c2c7';
            case 'warning':
              return '1px solid #ffecb5';
            case 'success':
              return '1px solid #badbcc';
            default:
              return '1px solid #b6effb';
          }
        },
      }}
      action={
        <CloseIcon
          className={classes.iconClose}
          onClick={onClose}
          data-testid="close-icon"
          fill={theme.palette.primary.main}
        />
      }
    >
      {message}
    </Alert>
  );
};

export default CustomAlert;
